import React from 'react';

const ClientConversionTable = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-yellow-100 text-yellow-800 p-4 rounded shadow">
        ⚠️ Debug: Client conversion data is missing or empty.
      </div>
    );
  }

  return (
    <div className="bg-white rounded shadow p-4 mt-6">
      <h2 className="text-lg font-semibold mb-4">Client Conversion Table</h2>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr>
            <th className="border-b p-2">Week</th>
            <th className="border-b p-2">Inquiries</th>
            <th className="border-b p-2">Referrals Out</th>
            <th className="border-b p-2">First Sessions</th>
            <th className="border-b p-2">Conversion Rate (%)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((entry, idx) => {
            const conversionRate =
              entry.inquiries > 0
                ? ((entry.firstSessions / entry.inquiries) * 100).toFixed(1)
                : '—';
            return (
              <tr key={idx}>
                <td className="border-b p-2">{entry.week}</td>
                <td className="border-b p-2">{entry.inquiries}</td>
                <td className="border-b p-2">{entry.referralsOut}</td>
                <td className="border-b p-2">{entry.firstSessions}</td>
                <td className="border-b p-2">{conversionRate}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ClientConversionTable;
